module.exports = __webpack_public_path__ + "assets/img/2021-7-active.2ca19016.png";